import { z } from 'zod'

export const PropertyManagerSortKeySchema = z.enum([
  'buildings',
  'createdAt',
  'email',
  'name',
  'phone',
])

export const PropertyManagerSortKey = PropertyManagerSortKeySchema.enum

export type PropertyManagerSortKey = z.infer<typeof PropertyManagerSortKeySchema>
